<template>
  <div v-if="images.length" class="attachments">
    <a href="#" @click.prevent="showModal = !showModal">
      <span class="icon-images">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#000" d="M528 32H112c-26.51 0-48 21.49-48 48v16H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-16h16c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-48 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h16v240c0 26.51 21.49 48 48 48h368v16zm64-64c0 8.822-7.178 16-16 16H112c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h416c8.822 0 16 7.178 16 16v288zM176 200c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56 25.072 56 56 56zm0-80c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm240.971 23.029c-9.373-9.373-24.568-9.373-33.941 0L288 238.059l-31.029-31.03c-9.373-9.373-24.569-9.373-33.941 0l-88 88A24.002 24.002 0 0 0 128 312v28c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-92c0-6.365-2.529-12.47-7.029-16.971l-88-88zM480 320H160v-4.686l80-80 48 48 112-112 80 80V320z"/></svg>
      </span>
      <strong> {{ $lang.translate('track.label.images') }}</strong>
    </a>
    <Modal :active="showModal" class="padded with-backdrop size-md" @close="showModal = false">
      <vue-glide :perView="1">
        <vue-glide-slide v-for="(image, index) in images" :key="index">
          <img :src="image.url" />
        </vue-glide-slide>
        <template slot="control">
          <button class="slider__arrow slider__arrow--prev glide__arrow glide__arrow--prev" data-glide-dir="<"><i class="icon-caret-left"></i><span class="visually-hidden">Prev</span></button>
          <button class="slider__arrow slider__arrow--next glide__arrow glide__arrow--next" data-glide-dir=">"><i class="icon-caret-right"></i><span class="visually-hidden">Next</span></button>
        </template>
      </vue-glide>
    </Modal>
  </div>
</template>
<script>
import Modal from '../Modal'
import { Glide, GlideSlide } from 'vue-glide-js'

export default {
  name: 'AttachmentButton',
  props: {
    attachments: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  components: {
    Modal,
    [Glide.name]: Glide,
    [GlideSlide]: GlideSlide
  },
  computed: {
    images () {
      let images = []
      for (let i = 0, j = this.attachments.length; i < j; i++) {
        const attachment = this.attachments[i]
        if (attachment.images && attachment.images.length) {
          for (let k = 0, l = attachment.images.length; k < l; k++) {
            images.push(attachment.images[k])
          }
        }
      }
      return images
    }
  }
}
</script>
<style scoped>
.icon-images {
  display: inline-block;
  width: 1rem;
  height: 1rem;
}
.attachments {
  margin-top: 1rem;
}
a:hover,a:active, a:focus {
  text-decoration: underline;
}
::v-deep .modal-content {
  height: 600px;
  max-height: 90%;
}
::v-deep .modal-body,
.glide, ::v-deep .glide__track, ::v-deep .glide__slides {
  height: 100%;
}

::v-deep .glide__slide {
  text-align: center;
}

::v-deep .glide__slide img {
  max-height: 100%;
}

.slider__arrow {
  background: transparent;
  appearance: none;
  outline: none;
  border: none;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 2rem;
}

.slider__arrow--prev {
  left: -1rem;
}

.slider__arrow--next {
  right: -1rem;
}


</style>